import { Table } from "@ag-media/react-pdf-table";
import { View } from "@react-pdf/renderer";
import { ReactNode } from "react";
import { Style } from "@react-pdf/types";

export default function PrintBlock({
    children,
    style,
}: {
    children: ReactNode;
    style?: Style | Style[];
}) {
    return (
        <View
            style={{
                ...style,
            }}
        >
            <Table
                style={{ border: "0px", gap: "5px" }}
                weightings={[2, 4, 2]}
                trStyle={{
                    alignItems: "flex-start",
                }}
            >
                {children}{" "}
            </Table>
        </View>
    );
}
